import { useQuery } from '@tanstack/react-query';
import { apercuActif, requeteRh } from '../services/apercu';

/**
 * Ce qui attend la personne, module par module.
 *
 * UNE SEULE source pour la page d'accueil ET les badges du menu latéral :
 * deux appels donneraient deux chiffres, et c'est toujours celui qu'on ne
 * regarde pas qui a raison.
 */

export interface Compteurs {
  factures?: { a_valider: number; en_erreur: number };
  paiements?: { a_preparer?: number; a_valider?: number; a_exporter?: number };
  ndf?: {
    a_approuver?: number;
    mes_notes_refusees?: number;
    mes_depenses_libres?: number;
    mes_notes_en_cours?: number;
  };
  conges?: { a_approuver?: number; mes_demandes_en_cours?: number };
  tickets?: { a_traiter: number };
}

export function useCompteurs() {
  return useQuery({
    queryKey: ['accueil', apercuActif()],
    // L'accueil suit l'identité endossée : ses compteurs sont ceux de la
    // personne observée, pas ceux de l'observateur.
    queryFn: () => requeteRh<Compteurs>('/api/accueil'),
    retry: false,
    // Les chiffres doivent être justes en revenant d'un module où l'on vient
    // justement de traiter ce qu'ils comptaient.
    refetchOnMount: 'always',
  });
}

/**
 * Ce qui attend une ACTION de la personne dans une section, quand elle est
 * repliée.
 *
 * Ne compte que les validations en attente — ce qui retient quelqu'un d'autre.
 * Les rappels personnels (« vos dépenses non rattachées ») n'ont pas leur place
 * dans un badge : ils ne bloquent personne, et un badge qui ne descend jamais à
 * zéro cesse d'être lu.
 */
export function aValiderDansSection(section: string, c: Compteurs | undefined): number {
  if (!c) return 0;
  if (section === 'ressources-humaines') {
    return (c.ndf?.a_approuver ?? 0) + (c.conges?.a_approuver ?? 0);
  }
  if (section === 'finance') {
    return (c.factures?.a_valider ?? 0) + (c.paiements?.a_valider ?? 0);
  }
  if (section === 'support') return c.tickets?.a_traiter ?? 0;
  return 0;
}
